import { useGetUnitCategoryProps } from "./types";
import { Button } from "primereact/button";
import { UnitCategoryRead } from "@types";

export const useGetUnitCategory = ({
  onEdit,
  onDelete,
}: useGetUnitCategoryProps) => {
  const handleDeleteClick = (rowData: UnitCategoryRead) => {
    if (rowData && rowData.id) {
      onDelete(rowData.id);
    }
  };

  const columns = [
    { field: "label", header: "Category" },
    { field: "shortDescription", header: "Short Description" },
    { field: "mainDescription", header: "Main Description" },
    { field: "bestFor", header: "Best For" },
    {
      field: "actions",
      header: "",
      body: (rowData: UnitCategoryRead) => (
        <div className="flex gap-2">
          <Button
            icon="pi pi-pencil"
            className="p-button-text p-button-sm"
            onClick={() => onEdit(rowData)}
          />
          <Button
            icon="pi pi-trash"
            rounded
            outlined
            severity="danger"
            className="p-button-text p-button-sm"
            onClick={() => handleDeleteClick(rowData)}
          />
        </div>
      ),
    },
  ];

  return { columns };
};
